import { ElementRef, ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {
  ICloseReturnType,
  PlaceholderChildComponent
} from '@ispm/layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { TherapyEditPayload } from '../../classes/therapy-edit-payload.class';
import { get, set, cloneDeep } from 'lodash';
import { TherapiesActionCreatorService } from '../../services/therapies-action-creator.service';
import { ItherapyMatch } from '../../interfaces/therapy-match.interface';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'gen-edit-therapy-modal',
  templateUrl: './edit-therapy-modal.component.html',
  styleUrls: ['./edit-therapy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditTherapyModalComponent extends PlaceholderChildComponent implements OnInit, OnDestroy {
  payload: TherapyEditPayload;
  submitted: boolean = false;

  constructor(
    private _therapyAC: TherapiesActionCreatorService,
    private _changeDetector: ChangeDetectorRef,
    private _element: ElementRef
  ) {
    super();
  }

  beforeClose(_modalResponse?: modalResponse): ICloseReturnType {
    switch (_modalResponse) {
        case modalResponse.approve:
          this.submitted = true;
          this._changeDetector.markForCheck();
          this._changeDetector.detectChanges();
          return this._therapyAC.updateTherapyMatch(this.payload.therapy, this.payload.testId)
                .pipe(debounceTime(300)) // debounce added for applying changed field trigger
                .toPromise()
                .then(res => {
                  return ({ isValid: true, therapy: res });
                })
                .catch(() => {
                  return ({ isValid: false });
                });
      default:
        break;

    }
  }

  trackByConfig(index, config) {
    return `${index}_${config.path}`;
  }

  trackByItem(index, item) {
    return this.getItemId(item);
  }

  ngOnInit() {
    super.ngOnInit();
    this.payload.therapy = cloneDeep(this.payload.therapy);

  }

  getFromPath(path) {
    return path ? get(this.payload.therapy, path) : this.payload.therapy;
  }

  getItemId(item) {
    if (!(item.id || item['internalClientId'])) {
      item['internalClientId'] = StringUtils.generateGuid();
    }
    return item.id || item['internalClientId'];
  }

  updateTherapy(form: any, path: any = '', index: number) {
    if (index !== null && index !== undefined) {
      path += `[${index}]`;
    }
    if (path) {
      set(this.payload.therapy, path, form);
    } else {
      Object.assign(this.payload.therapy, form);
    }
    this.payload.therapy['edited'] = true;
  }

  ngOnDestroy(): void {
    this.payload.forms.forEach(form => delete form['showItems']);
  }

  addItem(path: string) {
    let value = this.getFromPath(path);
    value = value || [];
    value.push({ });
    this.setToPath(path, value);
  }

  removeItem(value: any[], index: number) {
    value.splice(index, 1);
  }

  toggleItems(form: any) {
    form['showItems'] = !form['showItems'];
  }

  private setToPath(path: string, value: ItherapyMatch) {
    path
      ? set(this.payload.therapy, path, value)
      : set(this.payload, 'therapy', value);
  }
}
